import { ImageSourcePropType } from 'react-native'

export const TSFLogo = require('./assets/tsf_logo.png') as ImageSourcePropType
export const NewLeadDefaultLogo = require('./assets/newlead.png') as ImageSourcePropType
export const ArchivedDefaultLogo = require('./assets/archivedlead.png') as ImageSourcePropType
